<mat-toolbar color="primary" class="header-toolbar">
    <div style="text-align: left;">
        <small class="mr-1"><img src="../../../assets/logo.png" width="48" height="48"></small>
    </div>
    <div style="text-align: center;">
        <small class="mr-1 textoGeral"> {{title}} </small>
    </div>
    <div style="text-align: end;">
        <i class="fa fa-bars cursorHand" aria-hidden="true" [matMenuTriggerFor]="menu"></i>
        <mat-menu #menu="matMenu">
            <small mat-menu-item class="textoGeral" *ngIf="connectionStatus"> <i class="fa fa-circle" aria-hidden="true"
                    style="color: green" matToolTip="Online"></i> Status Online</small>
            <small mat-menu-item class="textoGeral" *ngIf="!connectionStatus"> <i class="fa fa-circle"
                    aria-hidden="true" style="color: red" matToolTip="Offline"></i> Status Offline</small>
            <small mat-menu-item class="mr-1"><i class="fa fa-user iconMenu" aria-hidden="true"></i> Usuário
                {{userName}}</small>
            <small mat-menu-item class="mr-1" (click)="goToRoute('', 'Formulários Disponíveis')"><i
                    class="fa fa-home iconCursor iconMenu" aria-hidden="true" matTooltip="Voltar menu"></i> Menu
                Principal</small>
            <small mat-menu-item class="mr-1" *ngIf="uploadPc0003"
                (click)="goToRoute('uploadFileToS3', 'Upload Pc003')"><i class="fa fa-upload iconCursor iconMenu"
                    aria-hidden="true" matTooltip="Upload pc003"></i> Upload Pc003</small>
            <small mat-menu-item class="mr-1" (click)="goToRoute('adm', 'Área Administrativa')"><i
                    class="fa fa-cog iconCursor iconMenu" aria-hidden="true" matTooltip="Área Administrativa"></i>
                    Área Administrativa
            </small>
            <!-- <small mat-menu-item class="mr-1" (click)="goToRoute('formule-config', 'Configuração de Fórmula')"><i class="fa fa-cog iconCursor iconMenu"
                        aria-hidden="true" matTooltip="Voltar menu"></i> Configuração de Fórmula</small>
                        <small mat-menu-item class="mr-1" (click)="goToRoute('rule-config', 'Configuração de Regra')"><i class="fa fa-cog iconCursor iconMenu"
                            aria-hidden="true" matTooltip="Voltar menu"></i> Configuração de Regra</small> -->
            <!-- <small mat-menu-item class="mr-1" (click)="refreshToken()" *ngIf="isDev"><i class="fa fa-refresh iconMenu"
                    aria-hidden="true"></i> Renovar Token</small> -->
        </mat-menu>
    </div>
</mat-toolbar>